/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1JacketpapersQueryResponse } from '../../types/GetV1Jacketpapers.ts'

export const getV1JacketpapersQueryKey = () => [{ url: '/v1/JacketPapers' }] as const

export type GetV1JacketpapersQueryKey = ReturnType<typeof getV1JacketpapersQueryKey>

/**
 * {@link /v1/JacketPapers}
 */
export async function getV1Jacketpapers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1JacketpapersQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/JacketPapers`,
        ...requestConfig,
    })
    return res
}

export function getV1JacketpapersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1JacketpapersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1JacketpapersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1JacketpapersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Jacketpapers(config)
        },
    })
}

/**
 * {@link /v1/JacketPapers}
 */
export function useGetV1Jacketpapers<
    TData = ResponseConfig<GetV1JacketpapersQueryResponse>,
    TQueryData = ResponseConfig<GetV1JacketpapersQueryResponse>,
    TQueryKey extends QueryKey = GetV1JacketpapersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1JacketpapersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1JacketpapersQueryKey()

    const query = useQuery(
        {
            ...getV1JacketpapersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
